import { useContext } from 'react';
import { ProAllowanceContext } from '../context/pro-allowance-context';
export var useProAllowance = function () {
    var context = useContext(ProAllowanceContext);
    if (!context) {
        throw new Error('useProAllowance must be used within a ProAllowanceProvider');
    }
    return context;
};
